import { trans } from "@mongez/localization";
import { settingsAtom } from "core/shared";
import { socialIcons } from "~/design-system/components";

export function FooterSocialMedia() {
  const social = settingsAtom.use("social");

  const socialKeys = social
    ? Object.keys(social).filter((k) => !!social[k])
    : [];

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-primary-dark text-lg font-semibold">
        {trans("socialMedia")}
      </h3>

      <ul className="flex w-full flex-wrap items-center gap-2">
        {socialKeys.map((socialKey) => {
          const SocialIcon = socialIcons[socialKey as keyof typeof socialIcons];
          const socialLink = social[socialKey as keyof typeof social];

          if (!SocialIcon || !socialLink) return null;

          return (
            <li key={socialKey}>
              <a
                aria-label={socialKey}
                href={socialLink}
                target="_blank"
                rel="noopener noreferrer"
                className="flex size-10 items-center justify-center rounded-full border"
              >
                <SocialIcon className="hover:text-primary-800 size-5 duration-300 lg:size-6" />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
